module.exports = __webpack_public_path__ + "img/icon-gp-128x128-02-tree.9d9746d2.svg";